<template>
    <v-container fill-height>
        <v-layout justify-center align-center>
            <v-flex xs6 lg4 v-if="!token && !mailSent">
                <h1>Passwort vergessen?</h1>
                Geben Sie Ihre E-Mail Adresse ein, um ein neues Passwort zu setzen
                <v-text-field
                        name="email"
                        :label="$t('email_address')"
                        type="email"
                        :disabled="loading"
                        v-model="email"
                        @keyup.enter="requestPassword"
                        autofocus
                        required
                ></v-text-field>

                <v-btn @click="requestPassword" :loading="loading" :disabled="loading" block>E-Mail anfordern</v-btn>
            </v-flex>
            <v-flex xs6 lg4 v-else-if="!token && mailSent">
                Es wurde ein Link an Ihre E-Mail Adresse verschickt
            </v-flex>
            <v-flex xs6 lg4 v-else>
                <v-text-field
                        id="password"
                        name="password"
                        :label="$t('new_password')"
                        :append-icon="passwordHidden ? 'visibility' : 'visibility_off'"
                        @click:append="() => (passwordHidden = !passwordHidden)"
                        :type="passwordHidden ? 'password' : 'text'"
                        :disabled="loading"
                        v-model="password"
                        @keyup.enter="submit"
                        autofocus
                        required
                ></v-text-field>

                <v-text-field
                        id="password_repeat"
                        name="password_repeat"
                        :label="$t('repeat_password')"
                        :type="passwordHidden ? 'password' : 'text'"
                        :disabled="loading"
                        v-model="password_repeat"
                        @keyup.enter="submit"
                        required
                ></v-text-field>

                <v-btn @click="submit" :loading="loading" :disabled="loading || !ready" block>Passwort ändern</v-btn>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    export default {
        data: () => ({
            token: null,
            userId: null,
            email: '',
            password: '',
            password_repeat: '',
            passwordHidden: true,
            loading: false,
            mailSent: false
        }),
        computed: {
            ready() {
                return this.password !== '' && this.password === this.password_repeat;
            }
        },
        mounted() {
            if (this.$route.params.hasOwnProperty('token')) {
                this.token = this.$route.params.token;
            }
            if (this.$route.params.hasOwnProperty('userId')) {
                this.userId = this.$route.params.userId;
            }
        },
        methods: {
            submit() {
                this.loading = true;

                axios.post(`/api/v1/users/${this.userId}/password`, {
                    password: this.password,
                    token: this.token
                }).then(response => {

                    if (!response.data.success) {
                        this.loading = false;
                        this.$store.commit('snackBar', {
                            color: 'error',
                            text: 'Fehler beim speichern'
                        });
                        return;
                    }

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: 'Passwort erfolgreich geändert'
                    });

                    this.loading = false;

                    if (this.token) {
                        this.$router.push('/login');
                    }

                }, errorResponse => {
                    console.error(errorResponse);
                    this.loading = false;
                    this.$store.commit('snackBar', {
                        color: 'error',
                        text: 'Fehler beim speichern'
                    });
                });
            },
            requestPassword() {
                this.loading = true;

                axios.post('/api/v1/users/request_password', {email: this.email}).then(response => {
                    if (!response.data.success) {
                        this.$store.commit('snackBar', {
                            color: 'error',
                            text: 'E-Mail konnte nicht zugeordnet werden'
                        });
                        this.loading = false;
                        return;
                    }

                    this.$store.commit('snackBar', {
                        color: 'success',
                        text: 'E-Mail wurde verschickt'
                    });

                    this.mailSent = true;
                    this.loading = false;
                });
            }
        }
    }
</script>
